import NaviBottom from '@/component/NaviBottom'
import NaviTop from '@/component/NaviTop'
import PageTransitionWrapper from '@/component/PageTransitionWrapper'
import usePrefetchAfterLogin from '@/hook/usePrefetchAfterLogin'
import { isLoggedInAtom } from '@/state'
import { AnimatePresence } from 'framer-motion'
import { useAtom } from 'jotai'
import Container from 'react-bootstrap/Container'
import { Navigate, useLocation, useOutlet, ScrollRestoration } from 'react-router-dom'
import { margin } from './style.css'

const PATHS = new Set(['intro', 'login'])

export default function RootLayout() {
  const [isLoggedIn] = useAtom(isLoggedInAtom)
  usePrefetchAfterLogin(isLoggedIn)

  const location = useLocation()
  const currentOutlet = useOutlet()

  return (
    <>
      <ScrollRestoration getKey={(location) => location.pathname} />
      <NaviTop />

      {!isLoggedIn && !PATHS.has(location.pathname.split('/')[1]) ? (
        <Navigate to="/intro" replace />
      ) : (
        <Container className={margin}>
          <AnimatePresence>
            {currentOutlet && (
              <PageTransitionWrapper key={location.pathname} direction={location.state?.direction}>
                {currentOutlet}
              </PageTransitionWrapper>
            )}
          </AnimatePresence>
        </Container>
      )}

      <NaviBottom />
    </>
  )
}
